module.exports = __webpack_public_path__ + "site/img/team_member_Abby.7d7f0522.jpg";